import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import type { History } from 'history'

import admin from 'models/admin/reducers'
import bag from 'models/bag/reducers'
import compositions from 'models/compositions/reducers'
import favorites from 'models/favorites/reducers'
import furniture from 'models/furniture/reducers'
import kiosk from 'models/kiosk/reducers'
import preview from 'models/preview/reducers'
import ratings from 'models/ratings/reducers'
import renderer from 'models/renderer/reducers'
import scenes from 'models/scenes/reducers'
import support from 'models/support/reducers'
import toasts from 'models/toasts/reducers'
import tracking from 'models/tracking/reducers'
import ui from 'models/ui/reducers'
import user from 'models/user/reducers'

export default (history: History) =>
    combineReducers({
        admin,
        bag,
        compositions,
        favorites,
        furniture,
        kiosk,
        preview,
        ratings,
        renderer,
        router: connectRouter(history),
        scenes,
        support,
        toasts,
        tracking,
        ui,
        user,
    })
